// extracted by mini-css-extract-plugin
export default {"Thumbnails":"📚19-10-2nNyj8","ThumbnailImage":"📚19-10-2Mh9qQ","ThumbnailOverflow":"📚19-10-2vw0MK"};